import { render, staticRenderFns } from "./Workspaces.vue?vue&type=template&id=46cea1b6&"
import script from "./Workspaces.vue?vue&type=script&lang=js&"
export * from "./Workspaces.vue?vue&type=script&lang=js&"
import style0 from "./Workspaces.vue?vue&type=style&index=0&id=46cea1b6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports